import { render, staticRenderFns } from "./PersonOrganizationModal.vue?vue&type=template&id=5084c875&"
import script from "./PersonOrganizationModal.vue?vue&type=script&lang=js&"
export * from "./PersonOrganizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports